module.exports = __webpack_public_path__ + "static/media/ba-pg2.2c27699b.jpg";